__turbopack_context__.v({
  "groupModalQuestions": "styles-module__HR1Bva__groupModalQuestions",
  "groupModalSubtitle": "styles-module__HR1Bva__groupModalSubtitle",
});
